<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import appConfig from "@/app.config";
import { required, helpers } from "vuelidate/lib/validators";
// import VueSingleSelect from "vue-single-select";

const registerNumberValidation = helpers.regex("alphaNumAndDot", /^[A-Z0-9]*$/);
// const onlyNumber = helpers.regex("alphaNumAndDot", /[+-]?([0-9]*[.])?[0-9]+/);
// import { param } from "express/lib/request";
/**
 * Add-product component
 */
export default {
  page: {
    title: "User-Vehicle",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {},
  data() {
    return {
      sortBy: "id",
      perPages: 5,
      sortDesc: true,
      page: 1,
      paginations: {},
      limit: 10,
      search: "",
      moment,
      id: "",
      booking: {
        is_cancel: [],
      },
      typeform: {
        selectedCharger: [],
        selectedVehicleMake: [],
        selectedChargerType: [],
        // selectedBatterySize: [],
        selectedVehicleModel: [],
      },
      vehicleMakeList: [],
      modelData: {
        id: "",
        vehicle_make_id: "",
        vehicle_model_id: "",
        registration_number: "",
        battery_size: "",
        mark_as_primary: 0,
      },
      chargerList: [],
      typeList: [],
      sizeList: [],
      chargerTypeList: [],
      chargerType: ["Type-1", "Type-2"],
      modelList: [],
      fields: [
        {
          key: "id",
          sortable: false,
          label: "#",
        },
        {
          key: "vehicle_make_name",
          sortable: true,
          label: "Vehicle Make",
        },
        {
          key: "vehicle_model_name",
          sortable: true,
          label: "Vehicle Model",
        },
        {
          key: "registration_number",
          sortable: true,
          label: "Registration Number",
        },
        {
          key: "size",
          sortable: true,
          label: "Battery Size",
        },
        {
          key: "type",
          sortable: true,
          label: "Charger Type",
        },
        {
          key: "action",
          sortable: false,
          label: "Action",
        },
      ],
    };
  },
  props: ["userId"],
  validations: {
    modelData: {
      registration_number: { registerNumberValidation },
      battery_size: { required },
    },
    typeform: {
      selectedVehicleModel: { required },
      selectedVehicleMake: { required },
      selectedChargerType: { required },
      // selectedBatterySize: { required },
    },
  },
  computed: {
    ...mapGetters("vehicle", [
      "getAllUserVehicle",
      "loading",
      "userVehicleCount",
      "pagination",
      "getAllMake",
      "getAllType",
      "getAllSize",
      "getAllModel",
      "getUpdateStatus",
      "getShowUserVehicle",
    ]),
  },
  mounted() {
    this.getUserVehicles(this.page);
    this.getMakes();
    this.getTypes();
    // this.getSizes();
    this.getChargerTypes();
  },
  methods: {
    ...mapActions("vehicle", [
      "getUserVehicle",
      "getMake",
      "getType",
      "getSize",
      "getModel",
      "addOrUpdateVehcile",
      "showUserVehicle",
      "deleteUserVehicle",
    ]),
    getUserVehicles(page = 1) {
      var filters = {
        search: this.search,
        sortBy: this.sortBy,
        orderBy: this.sortDesc ? "desc" : "asc",
        page: page && page > 0 ? page : 1,
        perPages: this.perPages,
        user_id: this.convertDecodeId(this.$route.params.id),
      };
      this.getUserVehicle(filters);
    },
    addVehicleDatailModel() {
      this.modelData.id = "";
      this.modelData.vehicle_make_id = "";
      this.modelData.vehicle_model_id = "";
      this.modelData.registration_number = "";
      this.modelData.battery_size = "";
      this.$bvModal.show("bv-modal-add-vehicle-detail");
    },
    dispatchAction(event) {
      let vehicle_make_id = event.id;
      this.typeform.selectedVehicleModel = [];
      this.typeform.selectedChargerType = [];
      this.modelData.battery_size = "";
      this.getModels(vehicle_make_id);
    },

    getBatterySize(event) {
      let charger_type_id = event.id;
      this.getSizes(charger_type_id);
    },

    async getSizes(charger_type_id) {
      if (charger_type_id && this.typeform.selectedVehicleModel.id) {
        var data = {
          charger_type_id: charger_type_id,
          vehicle_model_id: this.typeform.selectedVehicleModel.id,
        };
        await this.getSize(data);
        this.getAllBatterySize();
      }
    },
    async getMakes() {
      await this.getMake();
      this.getAllMakeList();
    },
    async getTypes() {
      await this.getType();
      this.getAllChargerType();
    },
    // async getSizes() {
    //   await this.getSize();
    //   this.getAllBatterySize();
    // },
    async getChargerTypes() {
      this.getAllChargerTypeList();
    },
    async getModels(vehicle_make_id) {
      let data = {
        make_id: vehicle_make_id,
      };
      await this.getModel(data);
      this.getAllModelList();
    },
    getAllMakeList() {
      this.chargerList = this.getAllMake.map((item) => ({
        id: item.id,
        name: item.name,
      }));
    },
    getAllChargerType() {
      this.typeList = this.getAllType.map((item) => ({
        id: item.id,
        type: item.type,
      }));
    },
    getAllBatterySize() {
      this.modelData.battery_size = this.getAllSize.name;
    },
    getAllChargerTypeList() {
      this.chargerTypeList = this.chargerType.map((item) => ({
        id: item.id,
        name: item.name,
      }));
    },
    getAllModelList() {
      this.modelList = this.getAllModel.map((item) => ({
        id: item.id,
        name: item.name,
      }));
    },
    convertDecodeId(id) {
      return (this.user_id = atob(id));
    },
    sortingChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.getUserVehicles();
    },
    submitAddForm() {
      this.$v.$touch();
      if (this.$v.modelData.$invalid || this.$v.typeform.$invalid) {
        return;
      } else {
        const fd = new FormData();
        fd.append("vehicle_make_id", this.typeform.selectedVehicleMake.id);
        fd.append("charger_type", this.typeform.selectedChargerType.id);
        fd.append("vehicle_model_id", this.typeform.selectedVehicleModel.id);
        if (this.modelData.registration_number) {
          fd.append("registration_number", this.modelData.registration_number);
        }
        fd.append("battery_size", this.modelData.battery_size);
        if (this.modelData.mark_as_primary) {
          fd.append("mark_as_primary", this.modelData.mark_as_primary);
        }
        // if (this.typeform.selectedBatterySize.id) {
        //   fd.append("battery_size", this.typeform.selectedBatterySize.id);
        // }
        fd.append("user_id", this.convertDecodeId(this.$route.params.id));
        this.addOrUpdateVehcile(fd).then((response) => {
          console.log(response);
          if (this.getUpdateStatus == 200) {
            this.getUserVehicles();
            this.$bvModal.hide("bv-modal-add-vehicle-detail");
          }
        });
      }
    },
    submitEditForm() {
      this.$v.$touch();
      if (this.$v.modelData.$invalid || this.$v.typeform.$invalid) {
        return;
      } else {
        const fd = new FormData();
        fd.append("id", this.modelData.id);
        fd.append("vehicle_make_id", this.typeform.selectedVehicleMake.id);
        fd.append("charger_type", this.typeform.selectedChargerType.id);
        fd.append("vehicle_model_id", this.typeform.selectedVehicleModel.id);
        fd.append("battery_size", this.modelData.battery_size);
        if (this.modelData.mark_as_primary) {
          fd.append("mark_as_primary", this.modelData.mark_as_primary);
        }
        if (this.modelData.registration_number) {
          fd.append("registration_number", this.modelData.registration_number);
        }
        // if (this.typeform.selectedBatterySize.id) {
        //   fd.append("battery_size", this.typeform.selectedBatterySize.id);
        // }
        fd.append("user_id", this.convertDecodeId(this.$route.params.id));
        this.addOrUpdateVehcile(fd).then((response) => {
          console.log(response);
          if (this.getUpdateStatus == 200) {
            this.getUserVehicles();
            this.$bvModal.hide("bv-modal-edit-vehicle-detail");
          }
        });
      }
    },
    editUserVehicle(user_vehicle_id) {
      this.resetForm();
      var data = {
        id: user_vehicle_id,
      };
      this.showUserVehicle(data).then(() => {
        console.log(this.getShowUserVehicle);
        this.modelData.id = this.getShowUserVehicle.id;
        this.typeform.selectedVehicleMake = this.getShowUserVehicle.vehicle_makes;
        this.typeform.selectedChargerType = this.getShowUserVehicle.charger_type;
        this.typeform.selectedVehicleModel = this.getShowUserVehicle.vehicle_models;
        this.modelData.registration_number = this.getShowUserVehicle.registration_number;
        this.modelData.battery_size = this.getShowUserVehicle.battery_size;
        this.modelData.mark_as_primary = this.getShowUserVehicle.mark_as_primary;
        console.log("pri", this.modelData.mark_as_primary);
        this.$bvModal.show("bv-modal-edit-vehicle-detail");
      });
    },
    deleteUserVehicles(user_vehicle_id) {
      if (confirm("Are You Sure to Delete #" + user_vehicle_id + " User Vehicle")) {
        const fd = new FormData();
        fd.append("id", user_vehicle_id);
        this.deleteUserVehicle(fd).then(() => {
          if (this.getUpdateStatus == 200) {
            this.getUserVehicles();
          }
        });
      }
    },
    handleClick() {
      if (this.$refs.theCheckbox.checked) {
        this.modelData.mark_as_primary = 1;
      } else {
        this.modelData.mark_as_primary = 0;
      }
    },
    resetForm() {
      this.typeform.selectedVehicleMake = [];
      this.typeform.selectedChargerType = [];
      //this.typeform.selectedBatterySize = [];
      this.typeform.selectedVehicleModel = [];
      this.modelList = [];
      this.$v.$reset();
    },
  },
};
</script>
<template>
  <div class="row">
    <div class="col-12">
      <form action="#" @submit.prevent="typeForm">
        <div class="card details-profile-main">
          <div class="card-body">
            <div class="col-12">
              <div
                class="page-title-box d-flex align-items-center justify-content-between icon-main-page"
              >
                <div class="page-title-left d-flex align-items-center">
                  <h4 class="mb-0 font-size-18">Vehicles ({{ userVehicleCount }})</h4>
                </div>
                <div class="page-title-right">
                  <b-button
                    class="page-title-right btn btn-success btn-rounded mr-2 add-btn"
                    @click="
                      addVehicleDatailModel();
                      $bvModal.show('bv-modal-add-vehicle-detail');
                    "
                    ><i class="mdi mdi-plus mr-1"></i>
                    Add Vehicle Detail
                  </b-button>
                  <!-- <a
                    :href="config.appurl + 'download-private-charger-data'"
                    class="btn btn-primary btn-md btn-rounded ml-1"
                  >
                    Download All Data
                  </a> -->
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <b-table
                  striped
                  hover
                  :items="getAllUserVehicle"
                  :update:sortBy="sortBy"
                  :update:sortDesc="sortDesc"
                  :no-local-sorting="true"
                  @sort-changed="sortingChanged"
                  :fields="fields"
                  :busy="loading"
                >
                  <template #table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>{{ $t(" Loading") }}</strong>
                    </div>
                  </template>
                  <template v-slot:cell(vehicle_make_name)="items">
                    {{ items.item.vehicle_make_name ? items.item.vehicle_make_name : "" }}
                    <span
                      v-if="items.item.mark_as_primary == 1"
                      class="badge badge-pill badge-info"
                      >P</span
                    >
                  </template>
                  <template v-slot:cell(vehicle_model_name)="items">
                    {{
                      items.item.vehicle_model_name ? items.item.vehicle_model_name : ""
                    }}
                  </template>
                  <template v-slot:cell(registration_number)="items">
                    {{
                      items.item.registration_number
                        ? items.item.registration_number
                        : "-"
                    }}
                  </template>
                  <template v-slot:cell(battery_size)="items">
                    {{ items.item.battery_size ? items.item.battery_size : "-" }}
                  </template>
                  <template v-slot:cell(charger_type)="items">
                    {{ items.item.charger_type ? items.item.charger_type : "-" }}
                  </template>
                  <template v-slot:cell(action)="items">
                    <b-button
                      @click="editUserVehicle(items.item.id)"
                      class="btn btn-success btn-rounded"
                    >
                      <i class="bx bxs-edit"></i>
                    </b-button>
                    &nbsp;
                    <b-button
                      @click="deleteUserVehicles(items.item.id)"
                      class="btn btn-danger btn-rounded"
                    >
                      <i class="bx bx-trash"></i>
                    </b-button>
                  </template>
                </b-table>
                <tr v-if="loading == false && getAllUserVehicle.length === 0">
                  <td colspan="100%">
                    <h6 align="center">No Vehicle Data Found</h6>
                  </td>
                </tr>
              </div>
              <div class="row col-sm-5 offset-sm-7">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                      <pagination
                        :data="pagination"
                        :limit="limit"
                        @pagination-change-page="getUserVehicles"
                      ></pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <b-modal id="bv-modal-add-vehicle-detail" hide-footer @hidden="resetForm">
      <template #modal-title>Add Vehicle Detail</template>
      <form action="#" @submit.prevent="submitAddForm">
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group mb-3">
              <label>Vehicle Make</label>
              <multiselect
                v-model="typeform.selectedVehicleMake"
                id="ajax"
                v-bind:disabled="typeform.checkbox"
                label="name"
                track-by="name"
                class="w-100"
                placeholder="Search Vehicle Make"
                open-direction="bottom"
                :options="chargerList"
                :multiple="false"
                :searchable="true"
                :internal-search="true"
                :clear-on-select="true"
                :close-on-select="true"
                :max-height="600"
                :show-no-results="false"
                :hide-selected="true"
                @select="dispatchAction"
                :class="{ 'is-invalid': $v.typeform.selectedVehicleMake.$error }"
              >
              </multiselect>
              <div v-if="$v.typeform.selectedVehicleMake.$error" class="invalid-feedback">
                <span v-if="!$v.typeform.selectedVehicleMake.required"
                  >Please select vehicle make name.</span
                >
              </div>
            </div>
          </div>
          <div class="col-sm-12">
            <div class="form-group mb-3">
              <label>Vehicle Model</label>
              <multiselect
                v-model="typeform.selectedVehicleModel"
                id="ajax"
                v-bind:disabled="typeform.checkbox"
                label="name"
                track-by="name"
                class="w-100"
                placeholder="Search Vehicle Model"
                open-direction="bottom"
                :options="modelList"
                :multiple="false"
                :searchable="true"
                :internal-search="true"
                :clear-on-select="true"
                :close-on-select="true"
                :max-height="600"
                :show-no-results="false"
                :hide-selected="true"
                :class="{ 'is-invalid': $v.typeform.selectedVehicleModel.$error }"
              >
              </multiselect>
              <div
                v-if="$v.typeform.selectedVehicleModel.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.typeform.selectedVehicleModel.required"
                  >Please select vehicle model name.</span
                >
              </div>
            </div>
          </div>
          <div class="col-sm-12">
            <div class="form-group mb-3">
              <label>Charger Type</label>
              <!-- <vue-single-select
                v-model="typeform.selectedChargerType"
                :options="chargerType"
                :required="true"
                :class="{ 'is-invalid': $v.typeform.selectedChargerType.$error }"
              ></vue-single-select> -->
              <multiselect
                v-model="typeform.selectedChargerType"
                id="ajax"
                v-bind:disabled="typeform.checkbox"
                label="type"
                track-by="type"
                class="w-100"
                placeholder="Search Charger Type"
                open-direction="bottom"
                :options="typeform.selectedVehicleModel.id ? typeList : []"
                :multiple="false"
                :searchable="true"
                :internal-search="true"
                :clear-on-select="true"
                :close-on-select="true"
                :max-height="600"
                :show-no-results="false"
                :hide-selected="true"
                @select="getBatterySize"
                :class="{ 'is-invalid': $v.typeform.selectedChargerType.$error }"
              >
              </multiselect>
              <div v-if="$v.typeform.selectedChargerType.$error" class="invalid-feedback">
                <span v-if="!$v.typeform.selectedChargerType.required"
                  >Please select charger type.</span
                >
              </div>
            </div>
          </div>
          <div class="col-sm-12">
            <div class="form-group mb-3">
              <label>Registration Number</label>
              <input
                id="name"
                type="text"
                class="form-control"
                placeholder="Enter Registration Number"
                v-model="$v.modelData.registration_number.$model"
                :class="{ 'is-invalid': $v.modelData.registration_number.$error }"
                name="name"
              />
              <div
                v-if="$v.modelData.registration_number.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.modelData.registration_number.registerNumberValidation"
                  >Please enter valid capital letters</span
                >
              </div>
            </div>
          </div>
          <div class="col-sm-12">
            <div class="form-group mb-3">
              <label>Battery Size</label>
              <input
                id="battery_size"
                type="text"
                class="form-control"
                placeholder="Enter Battery Size"
                v-model="$v.modelData.battery_size.$model"
                :class="{ 'is-invalid': $v.modelData.battery_size.$error }"
                name="name"
              />
              <div v-if="$v.modelData.battery_size.$error" class="invalid-feedback">
                <span v-if="!$v.modelData.battery_size.required"
                  >Please enter battery size</span
                >
              </div>
            </div>
          </div>
          <!-- <div class="col-sm-12">
            <div class="form-group mb-3">
              <label>Battery Size</label>
              <multiselect
                v-model="typeform.selectedBatterySize"
                id="ajax"
                v-bind:disabled="typeform.checkbox"
                label="name"
                track-by="name"
                class="w-100"
                placeholder="Search Battery Size"
                open-direction="bottom"
                :options="sizeList"
                :multiple="false"
                :searchable="true"
                :internal-search="true"
                :clear-on-select="true"
                :close-on-select="true"
                :max-height="600"
                :show-no-results="false"
                :hide-selected="true"
                :class="{ 'is-invalid': $v.typeform.selectedBatterySize.$error }"
              >
              </multiselect>
              <div v-if="$v.typeform.selectedBatterySize.$error" class="invalid-feedback">
                <span v-if="!$v.typeform.selectedBatterySize.required"
                  >Please select battery size</span
                >
              </div>
            </div>
          </div> -->
        </div>
        <div class="text-end mt-3">
          <button
            type="button"
            @click="
              resetForm();
              $bvModal.hide('bv-modal-add-vehicle-detail');
            "
            class="btn btn-light"
          >
            Close</button
          >&nbsp;
          <button type="submit" class="btn ms-1 btn-success">Submit</button>
        </div>
      </form>
    </b-modal>
    <b-modal id="bv-modal-edit-vehicle-detail" hide-footer @hidden="resetForm">
      <template #modal-title>Edit Vehicle Detail</template>
      <form action="#" @submit.prevent="submitEditForm">
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group mb-3">
              <label>Vehicle Make</label>
              <multiselect
                v-model="typeform.selectedVehicleMake"
                id="ajax"
                class="w-100"
                v-bind:disabled="typeform.checkbox"
                label="name"
                track-by="name"
                placeholder="Search Vehicle Make"
                open-direction="bottom"
                :options="chargerList"
                :multiple="false"
                :searchable="true"
                :internal-search="true"
                :clear-on-select="true"
                :close-on-select="true"
                :max-height="600"
                :show-no-results="false"
                :hide-selected="true"
                @select="dispatchAction"
                :class="{ 'is-invalid': $v.typeform.selectedVehicleMake.$error }"
              >
              </multiselect>
              <div v-if="$v.typeform.selectedVehicleMake.$error" class="invalid-feedback">
                <span v-if="!$v.typeform.selectedVehicleMake.required"
                  >Please select vehicle make name.</span
                >
              </div>
            </div>
          </div>
          <div class="col-sm-12">
            <div class="form-group mb-3">
              <label>Vehicle Model</label>
              <multiselect
                v-model="typeform.selectedVehicleModel"
                id="ajax"
                v-bind:disabled="typeform.checkbox"
                label="name"
                track-by="name"
                class="w-100"
                placeholder="Search Vehicle Model"
                open-direction="bottom"
                :options="modelList"
                :multiple="false"
                :searchable="true"
                :internal-search="true"
                :clear-on-select="true"
                :close-on-select="true"
                :max-height="600"
                :show-no-results="false"
                :hide-selected="true"
                :class="{ 'is-invalid': $v.typeform.selectedVehicleModel.$error }"
              >
              </multiselect>
              <div
                v-if="$v.typeform.selectedVehicleModel.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.typeform.selectedVehicleModel.required"
                  >Please select vehicle model name.</span
                >
              </div>
            </div>
          </div>
          <div class="col-sm-12">
            <div class="form-group mb-3">
              <label>Charger Type</label>
              <multiselect
                v-model="typeform.selectedChargerType"
                id="ajax"
                v-bind:disabled="typeform.checkbox"
                label="type"
                track-by="type"
                class="w-100"
                placeholder="Search Charger Type"
                open-direction="bottom"
                :options="typeList"
                :multiple="false"
                :searchable="true"
                :internal-search="true"
                :clear-on-select="true"
                :close-on-select="true"
                :max-height="600"
                :show-no-results="false"
                :hide-selected="true"
                @select="getBatterySize"
                :class="{ 'is-invalid': $v.typeform.selectedChargerType.$error }"
              >
              </multiselect>
              <div v-if="$v.typeform.selectedChargerType.$error" class="invalid-feedback">
                <span v-if="!$v.typeform.selectedChargerType.required"
                  >Please select charger type.</span
                >
              </div>
            </div>
          </div>
          <div class="col-sm-12">
            <div class="form-group mb-3">
              <label>Registration Number</label>
              <input
                id="name"
                type="text"
                class="form-control"
                placeholder="Enter Registration Number"
                v-model="$v.modelData.registration_number.$model"
                :class="{ 'is-invalid': $v.modelData.registration_number.$error }"
                name="name"
              />
              <div
                v-if="$v.modelData.registration_number.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.modelData.registration_number.registerNumberValidation"
                  >Please enter valid capital letters</span
                >
              </div>
            </div>
          </div>
          <div class="col-sm-12">
            <div class="form-group mb-3">
              <label>Battery Size</label>
              <input
                id="battery_size"
                type="text"
                class="form-control"
                placeholder="Enter Battery Size"
                v-model="$v.modelData.battery_size.$model"
                :class="{ 'is-invalid': $v.modelData.battery_size.$error }"
                name="name"
              />
              <div v-if="$v.modelData.battery_size.$error" class="invalid-feedback">
                <span v-if="!$v.modelData.battery_size.required"
                  >Please enter battery size</span
                >
              </div>
            </div>
          </div>
          <!-- <div class="col-sm-12">
            <div class="form-group mb-3">
              <label>Battery Size</label>
              <multiselect
                v-model="typeform.selectedBatterySize"
                id="ajax"
                v-bind:disabled="typeform.checkbox"
                label="name"
                track-by="name"
                class="w-100"
                placeholder="Search Battery Size"
                open-direction="bottom"
                :options="sizeList"
                :multiple="false"
                :searchable="true"
                :internal-search="true"
                :clear-on-select="true"
                :close-on-select="true"
                :max-height="600"
                :show-no-results="false"
                :hide-selected="true"
                :class="{ 'is-invalid': $v.typeform.selectedBatterySize.$error }"
              >
              </multiselect>
              <div v-if="$v.typeform.selectedBatterySize.$error" class="invalid-feedback">
                <span v-if="!$v.typeform.selectedBatterySize.required"
                  >Please select battery size</span
                >
              </div>
            </div>
          </div> -->
          <div class="col-sm-12">
            <div class="form-group mb-3">
              <div class="form-check">
                <input
                  v-model="modelData.mark_as_primary"
                  class="form-check-input"
                  type="checkbox"
                  true-value="1"
                  false-value="0"
                  id="flexCheckChecked"
                  @click="handleClick"
                  ref="theCheckbox"
                />
                <!-- :checked="getShowUserVehicle.mark_as_primary == 1 ? 'true' : 'false'" -->
                <label class="form-check-label" for="flexCheckChecked">
                  Mark as primary vehicle
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="text-end mt-3">
          <button
            type="button"
            @click="
              resetForm();
              $bvModal.hide('bv-modal-edit-vehicle-detail');
            "
            class="btn btn-light"
          >
            Close</button
          >&nbsp;
          <button type="submit" class="btn ms-1 btn-success">Submit</button>
        </div>
      </form>
    </b-modal>
  </div>
</template>
